<div class="padding">
    <form [formGroup]="searchCriteriaDetails">
        <div class="flex-container">
            <div class="validated-form-field-container flex-container">
                <mat-form-field class="flex-item form-field" appearance="outline">
                    <mat-label>{{ 'common.labels.name' | transloco }}</mat-label>
                    <input matInput [formControlName]="'name'" name="name" [placeholder]="'common.labels.name' | transloco">
                </mat-form-field>
                <lib-error-bubble [control]="searchCriteriaDetails.get('name')!"
                    [message]="nameError$"></lib-error-bubble>
            </div>

        </div>
    </form>
</div>